import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { AnyProjectId } from '@portal-core/projects/constants/any-project-id.constant';
import { Project } from '@portal-core/projects/models/project.model';

@CollectionStateSelectors({
  stateType: ProjectsState
})
@State<ProjectsState>({
  name: ProjectsState.source
})
@Service({ autoProvided: false })
export class ProjectsState extends CollectionStateBase {
  static override source: string = 'Projects';

  static override readonly defaultItems: Project[] = [{
    Id: AnyProjectId,
    Initials: 'ANY',
    Name: 'Any Project'
  }];

  override getDefaultItems(): Project[] {
    return ProjectsState.defaultItems;
  }

  getSource(): string {
    return ProjectsState.source;
  }
}

@Service()
export class ProjectsDataService extends CollectionDataServiceBase<Project> {
  protected readonly stateType = ProjectsState;
}
